import axiosPrivate from "../../../api/axiosPrivate";
import {
  ASSIGN_PERMISSIONS,
  CREATE_PERMISSION,
  GET_PERMISSIONS,
} from "../../../api/constant";

// Create new permission
const createPermission = async (permissionData) => {
  const response = await axiosPrivate.post(CREATE_PERMISSION, permissionData);
  return response.data;
};
const assignPermissions = async (permissionData) => {
  const response = await axiosPrivate.post(ASSIGN_PERMISSIONS, permissionData);
  return response.data;
};
const getPermissions = async (requestData) => {
  const response = await axiosPrivate.get(
    `${GET_PERMISSIONS}?module_id=${requestData.module}&role_id=${requestData.role_id}`
  );
  return response.data;
};

const permissionService = {
  createPermission,
  getPermissions,
  assignPermissions,
};

export default permissionService;
